import { render, staticRenderFns } from "./VisitaGastroenterologicaView.vue?vue&type=template&id=245ef2b7"
import script from "./VisitaGastroenterologicaView.vue?vue&type=script&lang=js"
export * from "./VisitaGastroenterologicaView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports